<mat-card class="content-card">
  <mat-card-header>
    <mat-card-title>
      {{ title | translate }}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div echarts class="distribution-chart" [options]="chartOption"></div>
  </mat-card-content>
</mat-card>
